export interface IMembershipCallbackRequest {
  testRegion?: BrokerRegion;
  callBackUrl?: string;
  correlationID?: string;
  manifestGUID?: string;
  callBackState?: CallbackState;
  Amount?: number;
  cardHolderName?: string;
  ccLast4Digits?: string;
  cardType?: CallbackCardCodeEnum;
  expMonth?: string;
  expYear?: string;
  eCheckAccountHolderName?: string;
  eCheckAccountNumber?: string;
  eCheckRoutingNumber?: string;
  isAutoPayRequested?: boolean;
  isRecurringPaymentSuccessful?: boolean;
  isOneTimePaymentRequested?: boolean;
  isOneTimePaymentSuccessful?: boolean;
  isPostSoftErrorResubmissionRequested?: boolean;
  isStoredPaymentRequested?: boolean;
  isStoredPaymentSuccessful?: boolean;
  isScheduledPaymentRequested?: boolean;
  isScheduledPaymentSuccessful?: boolean;
  isERSPaymentRequested?: boolean;
  isERSPaymentSuccessful?: boolean;
  isNonPaymentFlow?: boolean;
  callBackType?: CallbackType;
  autoPayAction?: CallbackAutoPayAction;
  paymentMethod?: CallbackPaymentMethod;
  paymentPlan?: CallbackPaymentPlan;
  scheduledPaymentDate?: string;
  emailAddress?: string;
  alternateEmailAddress?: string;
  paymentTransactionType?: CallbackPaymentTransactionType;
}

export enum CallbackType {
  BeforeProcessPayment = 0,
  ProcessPaymentSuccess = 1,
  ProcessPaymentError = 2,
  ProcessPaymentCancelled = 3,
  PaymentDataUpdated = 4,
  BeforeStandaloneAutoPay = 5,
  ProcessStandaloneAutoPaySuccess = 6,
  ProcessStandaloneAutoPayError = 7,
  ProcessStandaloneAutoPayCancelled = 8,
  StandaloneAutoPayDataUpdated = 9,
  ERSPayment = 10,
}

export enum CallbackState {
  BeforeProcessPayment = 'BeforeProcessPayment',
  ProcessPaymentSuccess = 'ProcessPaymentSuccess',
  ProcessPaymentError = 'ProcessPaymentError',
  ProcessPaymentCancelled = 'ProcessPaymentCancelled',
  PaymentDataUpdated = 'PaymentDataUpdated',
  BeforeStandaloneAutoPay = 'BeforeStandaloneAutoPay',
  ProcessStandaloneAutoPaySuccess = 'ProcessStandaloneAutoPaySuccess',
  ProcessStandaloneAutoPayError = 'ProcessStandaloneAutoPayError',
  ProcessStandaloneAutoPayCancelled = 'ProcessStandaloneAutoPayCancelled',
  StandaloneAutoPayDataUpdated = 'StandaloneAutoPayDataUpdated',
  ERSPayment = 'ERSPayment',
}

export enum CallbackCardCodeEnum {
  AMEX = 0,
  DISC = 1,
  MASTER = 2,
  VISA = 3,
  JCB = 4,
  DINERS = 5,
}

export enum CallbackAutoPayAction {
  Uninitialized = 0,
  Enroll = 1,
  Remove = 2,
  Update = 3,
}

export enum CallbackPaymentMethod {
  Unitialized = 0,
  Echeck = 1,
  CreditCard = 2,
  DebitCard = 3,
  Google = 4,
  Apple = 5,
}

export enum CallbackPaymentPlan {
  Unitialized = 0,
  Annual = 1,
  Installment = 2,
}

export enum CallbackPaymentTransactionType {
  StoredPayment = 'stored payment',
  OneTimePayment = 'one-time payment',
}

export enum BrokerRegion {
  A1 = 'A1',
  B1 = 'B1',
}
